// Mock data for Exciting.Travel - Latin America & Caribbean destinations

export const destinations = [
  {
    id: 'dest-001',
    name: 'Costa Rica Beach Clubs',
    image: 'https://images.unsplash.com/photo-1524481905007-ea072534b820?w=800',
    discount: '30% OFF',
    description: 'Party on pristine beaches with eco-certified beach clubs. All the thrills, zero guilt.',
    validUntil: 'July 31, 2025',
    location: 'Costa Rica',
    category: 'Beach & Nightlife'
  },
  {
    id: 'dest-002',
    name: 'Cartagena Street Food Tour',
    image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800',
    discount: '25% OFF',
    description: 'Explore colorful streets, taste authentic Colombian cuisine, and dance until sunrise.',
    validUntil: 'August 15, 2025',
    location: 'Colombia',
    category: 'Culture & Food'
  },
  {
    id: 'dest-003',
    name: 'Tulum Cenote Adventures',
    image: 'https://images.unsplash.com/photo-1518883222002-67c4f6c6b099?w=800',
    discount: '20% OFF',
    description: 'Swim in crystal cenotes, party at beach clubs, stay at eco-conscious hotels.',
    validUntil: 'September 1, 2025',
    location: 'Mexico',
    category: 'Adventure & Wellness'
  },
  {
    id: 'dest-004',
    name: 'Jamaica Reggae Vibes',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    discount: '35% OFF',
    description: 'Immerse yourself in reggae culture, pristine beaches, and sustainable resorts.',
    validUntil: 'October 10, 2025',
    location: 'Jamaica',
    category: 'Music & Beach'
  }
];

export const packages = [
  {
    id: 'pkg-001',
    name: 'Medellín Social Scene',
    image: 'https://images.unsplash.com/photo-1568632234157-ce7aecd03d0d?w=800',
    description: 'Experience Colombia\'s most vibrant city. Rooftop bars, street art tours, salsa clubs, and sustainable coffee farms. Carbon-neutral transport included.',
    duration: '7 days / 6 nights',
    spots: 15,
    price: 1499,
    location: 'Colombia',
    category: 'City & Culture',
    highlights: ['Rooftop parties', 'Street art tours', 'Eco-coffee farms', 'Salsa lessons'],
    sustainable: true,
    groupSize: 'Small groups (8-15)',
    included: ['Eco-certified hotels', 'Carbon-neutral transport', 'Local guides', 'Group dinners']
  },
  {
    id: 'pkg-002',
    name: 'Cancun All-In Conscious',
    image: 'https://images.unsplash.com/photo-1569003339405-ea396a5a8a90?w=800',
    description: 'All-inclusive luxury without the guilt. Eco-certified resort, zero single-use plastics, and incredible beach clubs. Party sustainably.',
    duration: '5 days / 4 nights',
    spots: 20,
    price: 1299,
    location: 'Mexico',
    category: 'Beach & All-Inclusive',
    highlights: ['Eco-resort', 'Beach clubs', 'Cenote diving', 'Mayan ruins'],
    sustainable: true,
    groupSize: 'Flexible (solo to groups)',
    included: ['All-inclusive eco-resort', 'Beach club access', 'Water activities', 'Airport transfers']
  },
  {
    id: 'pkg-003',
    name: 'Belize Barrier Reef & Beats',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    description: 'Snorkel the world\'s second-largest barrier reef, party at beach bonfires, stay in sustainable bungalows. Adventure meets conservation.',
    duration: '6 days / 5 nights',
    spots: 12,
    price: 1799,
    location: 'Belize',
    category: 'Adventure & Marine',
    highlights: ['Barrier reef snorkeling', 'Beach parties', 'Marine conservation', 'Island hopping'],
    sustainable: true,
    groupSize: 'Small groups (8-12)',
    included: ['Eco-bungalows', 'Snorkel gear', 'Conservation workshop', 'Boat transfers']
  },
  {
    id: 'pkg-004',
    name: 'Rio de Janeiro Energy',
    image: 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=800',
    description: 'Copacabana beaches, samba clubs, hang gliding, and favela tours with local guides. Experience Rio\'s infectious energy responsibly.',
    duration: '8 days / 7 nights',
    spots: 18,
    price: 1899,
    location: 'Brazil',
    category: 'City & Adventure',
    highlights: ['Samba clubs', 'Hang gliding', 'Favela tours', 'Beach culture'],
    sustainable: true,
    groupSize: 'Medium groups (12-18)',
    included: ['Central hotel', 'Local guides', 'Adventure activities', 'Group experiences']
  },
  {
    id: 'pkg-005',
    name: 'Panama City to Bocas',
    image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=800',
    description: 'Urban exploration meets island paradise. Modern Panama City, then tropical Bocas del Toro islands. Best of both worlds.',
    duration: '9 days / 8 nights',
    spots: 14,
    price: 2099,
    location: 'Panama',
    category: 'City & Beach',
    highlights: ['Panama Canal', 'Rooftop bars', 'Island hopping', 'Snorkeling'],
    sustainable: true,
    groupSize: 'Small groups (10-14)',
    included: ['Hotels & eco-lodges', 'Domestic flights', 'Water taxis', 'City tours']
  },
  {
    id: 'pkg-006',
    name: 'Cuba Cultural Immersion',
    image: 'https://images.unsplash.com/photo-1555661939-c51d0c9c0c2b?w=800',
    description: 'Vintage cars, salsa dancing, cigar lounges, and local casas particulares. Experience authentic Cuba with conscious travel practices.',
    duration: '10 days / 9 nights',
    spots: 16,
    price: 2299,
    location: 'Cuba',
    category: 'Culture & History',
    highlights: ['Havana nightlife', 'Vintage car tours', 'Salsa clubs', 'Local stays'],
    sustainable: true,
    groupSize: 'Medium groups (12-16)',
    included: ['Casa particulares', 'Local guides', 'Cultural workshops', 'Internal transport']
  }
];

export const whyChooseUs = [
  {
    icon: 'Sparkles',
    title: 'Verified Sustainable',
    description: 'Eco-certified hotels, carbon-neutral transport, zero single-use plastics. We handle the guilt so you handle the fun.'
  },
  {
    icon: 'Users',
    title: 'Inclusive Vibes Only',
    description: 'Meet like-minded travelers. Small groups, big energy, and experiences designed for connection.'
  },
  {
    icon: 'Heart',
    title: 'Popular, Not Destructive',
    description: 'Hit the bucket-list spots without wrecking them. Local guides, community support, and responsible tourism.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Maya Rodriguez',
    age: 27,
    trip: 'Medellín Social Scene',
    image: 'https://i.pravatar.cc/150?img=5',
    review: 'Best trip ever! The rooftop parties were insane, and I loved that everything was eco-conscious. Made lifelong friends.',
    rating: 5
  },
  {
    id: 2,
    name: 'Jake Thompson',
    age: 24,
    trip: 'Cancun All-In Conscious',
    image: 'https://i.pravatar.cc/150?img=12',
    review: 'Finally, an all-inclusive that doesn\'t feel gross. Amazing beaches, great people, zero plastic waste.',
    rating: 5
  },
  {
    id: 3,
    name: 'Sofia Chen',
    age: 29,
    trip: 'Belize Barrier Reef & Beats',
    image: 'https://i.pravatar.cc/150?img=9',
    review: 'Snorkeling was incredible! The conservation workshop was eye-opening. This is how travel should be.',
    rating: 5
  }
];
